enum EventImageType {
  banner = 1,
  detail = 2,
}

export default EventImageType;
